/**
 * RESPONSIBILITY: put a @RenderOf value on the page.
 *
 * THE ONLY dangerouslySetInnerHTML IN THE CODEBASE. Deliberately one place, so the
 * question "can an editor inject script into this site" has exactly one file to read.
 *
 * It is safe here because of what the value IS, not because of anything checked at this
 * point:
 *
 *   · it was produced by the framework's own markdown render, with raw HTML disabled, so
 *     it can only contain tags remark was permitted to emit
 *   · it lands in a @RenderOf field, which is ALWAYS overwritten on save and never read
 *     from the request — no bytes a client sent can reach it
 *
 * Passing anything else through here breaks both, so do not. If a value did not come out
 * of a @RenderOf field, it does not belong in this component.
 */

export interface HtmlProps {
  /** A @RenderOf field's value. Nothing else. */
  children: string | null | undefined;
  /** Wrapper class, so a site styles `.md-body ul` once rather than every element. */
  className?: string;
}

export function Html({ children, className = 'md-body' }: HtmlProps) {
  // An unsaved section has no rendered value yet. Render nothing rather than an empty
  // wrapper that a stylesheet would still give margins to.
  if (!children) return null;

  return <div className={className} dangerouslySetInnerHTML={{ __html: children }} />;
}
